import React, { useState } from "react";
import { Download, ChevronDown, ExternalLink } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export function PdfPages({ token, step }) {
  const [shown, setShown] = useState(3);
  const n = step.pages || 0;
  const src = (i) => `${BASE}/api/hr/public/onboarding/${token}/pdf/${step.index}/page/${i}`;
  return (
    <div className="space-y-2" data-testid="pack-pdf">
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-slate-500">{n} page{n === 1 ? "" : "s"} · your personalised copy</span>
        <span className="flex gap-3">
          <a href={`${BASE}/api/hr/public/onboarding/${token}/pdf/${step.index}`} target="_blank" rel="noreferrer" data-testid="pack-pdf-open" className="inline-flex items-center gap-1 text-xs font-semibold text-indigo-600"><ExternalLink size={13} /> Open full PDF</a>
          <a href={`${BASE}/api/hr/public/onboarding/${token}/pdf/${step.index}?download=1`} data-testid="pack-pdf-download" className="inline-flex items-center gap-1 text-xs font-semibold text-indigo-600"><Download size={13} /> Download</a>
        </span>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-slate-100 p-1 sm:p-2 space-y-2" data-testid="pack-pdf-pages">
        {Array.from({ length: Math.min(shown, n) }).map((_, i) => (
          <img key={i} src={src(i)} alt={`Page ${i + 1}`} loading="lazy" className="w-full bg-white rounded-lg shadow-sm" data-testid={`pack-pdf-page-${i}`} />
        ))}
        {shown < n && <button onClick={() => setShown(n)} data-testid="pack-pdf-more" className="w-full h-11 rounded-xl bg-white text-sm font-semibold text-indigo-600 inline-flex items-center justify-center gap-1"><ChevronDown size={15} /> Show all {n} pages</button>}
      </div>
    </div>
  );
}

export function SignedCopies({ token, steps }) {
  const done = steps.filter((s) => s.pdf && s.signed_copy);
  if (!done.length) return null;
  return (
    <div className="space-y-2" data-testid="pack-signed-copies">
      {done.map((s) => (
        <a key={s.index} href={`${BASE}/api/hr/public/onboarding/${token}/pdf/${s.index}?download=1`} data-testid={`pack-signed-download-${s.index}`}
          className="flex items-center gap-2 rounded-2xl border border-teal-200 bg-teal-50 px-4 h-12 text-sm font-semibold text-teal-700"><Download size={16} /> Download your signed {s.template_name}</a>
      ))}
      {done.some((s) => (s.copy_sent_via || []).length) && <p className="text-[11px] text-slate-400">We've also sent you a link to your signed copy by {[...new Set(done.flatMap((s) => s.copy_sent_via || []))].join(" and ")}.</p>}
    </div>
  );
}
